import PropTypes from 'prop-types';
import React from 'react';

import { IconPlay } from '$partials/icons';

import {
    Player,
    PlayerContextConsumer,
    PlayerEmbed,
    PlayerPlaceholder,
    PlayerPlayButton
} from '$partials/base/player.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
export const Media = ({
    buttonPlacement = 'center',
    image = null,
    video = null,
    videoPlatformEmbed = null
}) => {
    // misc
    let buttonClass;
    if (buttonPlacement === 'left') {
        buttonClass = 'absolute top-6/12 left-0 -translate-x-6/12 -translate-y-6/12 expand-interaction__action';
    } else {
        buttonClass = 'absolute top-6/12 left-6/12 -translate-x-6/12 -translate-y-6/12 expand-interaction__action';
    }

    // render
    return (
        <Player
            className='h-full w-full relative'
            shouldPrerender={true}>
            {video && !videoPlatformEmbed && (
                <video
                    autoPlay
                    disablePictureInPicture
                    loop
                    muted
                    playsInline
                    className='h-full w-full object-cover object-center pointer-events-none'
                    src={video.url} />
            )}

            {(!video && (image || videoPlatformEmbed)) && (
                <PlayerContextConsumer>
                    {({ isPlaying }) => {
                        return (
                            <>
                                {(image && !videoPlatformEmbed) && (
                                    <img
                                        alt={image.alt || null}
                                        className='h-full w-full object-center object-cover pointer-events-none'
                                        height={image.height}
                                        src={image.px2 || image.x2}
                                        width={image.width} />
                                )}

                                {(image && videoPlatformEmbed) && (
                                    <PlayerPlaceholder className={`relative h-full w-full expand-interaction transition-opacity ease-out duration-500${isPlaying ? ' opacity-0 z-0' : ' opacity-100 z-100'}`}>
                                        {image && (
                                            <img
                                                alt={image.alt || null}
                                                className='h-full w-full object-center object-cover pointer-events-none'
                                                height={image.height}
                                                src={image.px2 || image.x2}
                                                width={image.width} />
                                        )}

                                        {videoPlatformEmbed && (
                                            <PlayerPlayButton className={buttonClass}>
                                                <span aria-label='Play video'>
                                                    <IconPlay />
                                                </span>
                                            </PlayerPlayButton>
                                        )}
                                    </PlayerPlaceholder>
                                )}

                                <PlayerEmbed className={`absolute top-0 left-0 h-full w-full object-center object-cover transition-opacity ease-out duration-500${isPlaying ? ' opacity-100 z-10' : ' opacity-0 -z-10'}`}>
                                    {videoPlatformEmbed && (
                                        <div
                                            className='html-embed html-embed--h-full h-full w-full object-center object-cover'
                                            dangerouslySetInnerHTML={{ __html: videoPlatformEmbed.html }} />
                                    )}
                                </PlayerEmbed>
                            </>
                        );
                    }}
                </PlayerContextConsumer>
            )}
        </Player>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    buttonPlacement: PropTypes.string,
    image: PropTypes.object,
    video: PropTypes.object,
    videoPlatformEmbed: PropTypes.object
};

Media.propTypes = propTypes;

export default Media;
